module.exports = __webpack_public_path__ + "img/水晶鞋.e6cd2d3d.png";